import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.error),
  groups: () => slice((state) => state.groups),
  firstEventType: () =>
    slice((state) => {
      const eventTypes = Object.values(state.eventTypes);
      return eventTypes.length ? eventTypes[0] : null;
    })
}));
